import dayjs from 'dayjs'

// sessionStorage marker set just before a recovery reload and consumed on the next
// page load, so the load can be attributed to the reload. The TTL keeps a marker
// whose reload never completed (stop button, another navigation) from labeling an
// unrelated later page load.
export const createSessionMarker = (key: string, ttl: number) => ({
    mark: (): void => {
        try {
            sessionStorage.setItem(key, String(dayjs().valueOf()))
        }
        catch { /* sandboxed iframe / private mode: the post-reload label is lost */ }
    },
    claim: (): boolean => {
        try {
            const markedAt = Number(sessionStorage.getItem(key))
            if (markedAt && dayjs().valueOf() - markedAt < ttl) return false
            sessionStorage.setItem(key, String(dayjs().valueOf()))
            return true
        }
        catch {
            return false
        }
    },
    consume: (): boolean => {
        try {
            const markedAt = Number(sessionStorage.getItem(key))
            if (!markedAt) return false
            sessionStorage.removeItem(key)
            return dayjs().valueOf() - markedAt < ttl
        }
        catch {
            return false
        }
    },
})

// reloadNuxtApp decides internally whether to reload or let its 10s per-path guard swallow the
// call; its `nuxt:reload` entry changing across the call tells which happened. When sessionStorage
// is unavailable the guard fails open, so a reload always happens.
export const readReloadGuard = (): string | null | false => {
    try {
        return sessionStorage.getItem('nuxt:reload')
    }
    catch {
        return false
    }
}
